import { EventEmitter } from 'events';
import { ChangeEvent, TranscriptionEvent } from './utils';
import { LoadingActionTypes, LoadingStatus } from '../actions/LoadingActions';
import { LoadingState } from '../pages';
import Dispatcher from '../dispatcher';
import { LogError } from '../../utils/ErrorTelemetry';
import { LogEventNames } from '../../backend/interfaces/ITelemetryLogger';

const defaultState: LoadingState = {
  loadingStatus: LoadingStatus.LoadingTranscription,
  foregroundTask: null,
  percentDone: null
};

class LoadingStore extends EventEmitter {
  private state: LoadingState;

  constructor() {
    super();

    this.state = this.getInitialState();
  }

  private getInitialState = (): LoadingState => {
    // Make sure we are not passing a reference to the object
    return Object.assign({}, defaultState);
  }

  public getState = (): LoadingState => {
    // Make sure we are not passing a reference to the object
    return Object.assign({}, this.state);
  }

  public handleActions = (action: Event): void => {
    switch(action.type) {
      case LoadingActionTypes.SetForegroundTaskAction:
        this.state.foregroundTask =  (<TranscriptionEvent> action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case LoadingActionTypes.SetStatusAction:
        this.state.loadingStatus = (<TranscriptionEvent> action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case LoadingActionTypes.RevertStateAction:
        this.state = this.getInitialState();
        this.emit(ChangeEvent.Change);
        break;
      case LoadingActionTypes.SetPercentDoneAction:
        const payload = (<TranscriptionEvent> action).payload;

        if (payload != null) {
          if (payload < 0 || payload > 1) {
            LogError(LogEventNames.FileUpload, "Percent done is lower than 0 or higher than 1: " + payload);
            return;
          }
  
          if (this.state.percentDone != null && payload < this.state.percentDone) {
            // In practice, we see this happen constantly, but only for a handful of sessions
            // Since this appears to cause no apparent user bad, downgrading to warning for now
            LogError(LogEventNames.Warning, `Percent done is decreasing from ${this.state.percentDone} to ${payload}`);
            return;
          }
        }

        this.state.percentDone = (<TranscriptionEvent> action).payload;
        this.emit(ChangeEvent.Change);
        break;
    }
  }
}

const loadingStore = new LoadingStore;
Dispatcher.register(loadingStore.handleActions);
export default loadingStore;
